'use client';

import { c as _c } from "react/compiler-runtime";
import { GoogleMapsContext } from '@vis.gl/react-google-maps';
import { useContext, useEffect, useRef, useState } from 'react';
import { BranchMapMarker } from '@/components/GoogleMaps/BranchMapMarker';
import { breakpointUtils } from '@/lib/breakpoints';
import type { CmsMapMarker } from '@/services/cms-sdk';
export type LocationMapBlockMarkersProps = {
  markers: CmsMapMarker[];
};
export function LocationMapBlockMarkers(t0) {
  const $ = _c(11);
  const {
    markers
  } = t0;
  const {
    map
  } = useContext(GoogleMapsContext) ?? {};
  const didPan = useRef(false);
  const [activeMarker, setActiveMarker] = useState(undefined);
  let t1;
  let t2;
  if ($[0] !== map || $[1] !== markers) {
    t1 = () => {
      if (!map || didPan.current) {
        return;
      }
      const centerMap = function centerMap() {
        if (!map) {
          return;
        }
        if (markers.length === 1) {
          const marker = markers[0];
          map.setCenter({
            lat: marker.latitude,
            lng: marker.longitude
          });
          map.setZoom(marker.zoom || 14);
        } else {
          const bounds = new google.maps.LatLngBounds();
          for (const marker_0 of markers) {
            bounds.extend({
              lat: marker_0.latitude,
              lng: marker_0.longitude
            });
          }
          map.fitBounds(bounds);
        }
        const isMd = window.matchMedia(breakpointUtils.down("lg"));
        if (!isMd.matches) {
          const container = map.getDiv();
          const sizeObserver = container.parentElement?.querySelector(".map-size-observer") || container;
          const mapWidth = sizeObserver.clientWidth;
          const panOffset = -(mapWidth / 4);
          map.panBy(panOffset, 0);
        }
      };
      centerMap();
      const resizeObserver = new ResizeObserver(() => {
        centerMap();
      });
      resizeObserver.observe(map.getDiv());
      return () => {
        resizeObserver.disconnect();
      };
    };
    t2 = [map, markers];
    $[0] = map;
    $[1] = markers;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== activeMarker || $[5] !== markers) {
    let t4;
    if ($[7] !== activeMarker) {
      t4 = branch => <BranchMapMarker key={`${branch.latitude}-${branch.longitude}`} branch={branch} activeMarker={activeMarker} setActiveMarker={setActiveMarker} />;
      $[7] = activeMarker;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = markers.map(t4);
    $[4] = activeMarker;
    $[5] = markers;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <>{t3}</>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}